import layer from './layer'

export default {
  mixins: [
    layer,
  ],
}
